import { bindActionCreators as bindActions } from "redux";
import { connect } from "react-redux";
//
import { getGenderName } from "../utils";

import {
  getCity,
  getModelsOnline,
  getModelsOffline,
  getActiveFilterValues,
  isPremiumIn,
} from "../selectors";
import ModelListScreen from "../components/ModelListScreen";
import {
  setAreaAction,
  setModelsVisibleAction,
} from "../modules/models/actions";
import { setOrderByAction } from "../modules/filters";

const props = (state) => {
  const { auth, booking, modal, models } = state;

  const modelsOnline = getModelsOnline(state);
  const modelsOffline = getModelsOffline(state);
  const filters = getActiveFilterValues(state);
  const city = getCity(state);

  let premiumAlert = null;

  if (city.matured && !isPremiumIn(state)) {
    premiumAlert =
      "See more companions? Offline model browsing is available for _Premium members_.";
  }

  return {
    premiumAlert,
    areaId: models.areaId,
    city,
    isActive: modal.screen === "models",
    genderName: getGenderName(booking.genderId),
    models: modelsOnline,
    modelsOffline,
    modelsCount: modelsOnline.length,
    filtersCount: filters.length,
    user: auth.user,
    selectedTab: models.visible,
    orderRaw: state.filters.orderRaw,
  };
};

const actions = (dispatch) =>
  bindActions(
    {
      setModelsVisible: setModelsVisibleAction,
      setArea: setAreaAction,
      setOrderBy: setOrderByAction,
    },
    dispatch
  );

export default connect(
  props,
  actions
)(ModelListScreen);
